<template>
  <div class="shoppingCart">
    <div class="shoppingCartContent" style="">
      <!-- 默认的下拉刷新层 -->
      <!-- <div class="pull-to-refresh-layer scroll-container">
                <div class="preloader"></div>
                <div class="pull-to-refresh-arrow"></div>
            </div> -->
      <div class="normalCar scroll-container" v-show="shoppingCarts.length > 0">
        <div class="pullDownRefresh">
          <img
            src="https://resource.rcclchina.com.cn/tui2/shoppingcart/icon08.png"
          />
          下拉刷新获取最新价格及库存信息
        </div>

        <div id="carCategory-normal1" :class="{ hide: isNavFixed }">
          <div class="carCategory">
            <div class="carCategory-tab carCategory-tab-l">
              <img
                class="carCategory-tab-bg"
                src="https://resource.rcclchina.com.cn/tui2/shoppingcart/tab_hp.png"
              />

              <div class="carCategory-tab-txt">
                中国出发航线
                <div class="carCategory-tab-num js-carCategoryNum1">
                  {{ hpShoppingCartCount }}
                </div>
              </div>
            </div>
            <a
              :href="rowShoppingCartLink"
              class="carCategory-tab carCategory-tab-r external"
            >
              <img
                class="carCategory-tab-bg"
                src="https://resource.rcclchina.com.cn/tui2/shoppingcart/tab_row.png"
              />
              <div class="carCategory-tab-txt">
                海外出发航线
                <div class="carCategory-tab-num js-carCategoryNum2 dn">
                  {{ rowShoppingCartCount }}
                </div>
              </div>
            </a>
          </div>
        </div>

        <ShoppingCartCruise
          v-for="(cruiseShoppingCart, i) in cruiseShoppingCarts"
          :key="'cruise_' + i"
          :shoppingCarts="cruiseShoppingCart.shoppingCarts"
          :selectedShoppingCarts="
            getSelectShoppingCartsByCruise(
              cruiseShoppingCart.cruise.shipCode,
              cruiseShoppingCart.cruise.sailDate
            )
          "
          :onCruiseSelected="onCruiseSelected"
          :onStateroomSelected="onStateroomSelected"
          :onConnectRoomSelected="onConnectRoomSelected"
          :onAddShoppingCart="onAddShoppingCart"
          :onDeleteShoppingCart="onDeleteShoppingCart"
          :onDeleteConnectRoom="onDeleteConnectRoom"
          :onDeleteByStateroom="onDeleteByStateroom"
          :onDeleteCruiseClicked="onDeleteCruiseClicked"
          :showConnectRoomPopup="showConnectRoomPopup"
          :showQiaohuPopup="showQiaohuPopup"
          :showStarrySkyPopup="showStarrySkyPopup"
          :showCustomThemePopup="showCustomThemePopup"
        />
      </div>

      <div class="emptyCar scroll-container" v-show="shoppingCarts.length == 0">
        <!-- <div id="carCategory-emptyCar">
                    <div class="carCategory carCategory2 carCategory3">
                        <div class="carCategory-tab carCategory-tab-l">
                            <div class="carCategory-tab-txt">
                                中国出发航线<div class="carCategory-tab-num js-carCategoryNum1 dn">0</div>
                            </div>
                        </div>
                        <a href="/Rccl.Campaign/RedirectToTui?redirectUrl=http%3a%2f%2ftest.rclrow.com%2fBooking%2fMobileShoppingCart" class="carCategory-tab carCategory-tab-r external">
                            <div class="carCategory-tab-txt">
                                海外出发航线<div class="carCategory-tab-num js-carCategoryNum2 dn">0</div>
                            </div>
                        </a>

                    </div>
                </div> -->

        <div class="emptyCar-m">
          <img
            class="emptyCar-m-icon"
            src="https://resource.rcclchina.com.cn/tui2/shoppingcart/icon01.png"
          />
          <div class="emptyCar-m-txt">
            你的购物车还是空的～<br />
            这怎么能行，快来添加您的美好旅行计划吧！<br />
          </div>
          <div class="emptyCar-m-link">
            <router-link class="external" to="/Rccl.Cruise/CruiseSearch/Search"
              >搜索及添加心仪航线</router-link
            >
          </div>
        </div>
      </div>
    </div>

    <div
      id="carCategory-normal2"
      v-show="isNavFixed || shoppingCarts.length == 0"
    >
      <div class="carCategory carCategory2">
        <div class="carCategory-tab carCategory-tab-l">
          <div class="carCategory-tab-txt">
            中国出发航线
            <div class="carCategory-tab-num js-carCategoryNum1">
              {{ hpShoppingCartCount }}
            </div>
          </div>
        </div>
        <a
          :href="rowShoppingCartLink"
          class="carCategory-tab carCategory-tab-r external"
        >
          <div class="carCategory-tab-txt">
            海外出发航线
            <div class="carCategory-tab-num js-carCategoryNum2 dn">
              {{ rowShoppingCartCount }}
            </div>
          </div>
        </a>
      </div>
    </div>

    <CruiseShoppingCart
      v-show="shoppingCarts.length > 0"
      :isShowTips="true"
      :isDownPayCruise="selectedCruise.isDownPayCruise"
      :shipCode="selectedCruise.shipCode"
      :sailDate="selectedCruise.sailDate"
      :packageCode="selectedCruise.packageId"
      :shoppingCarts="selectShoppingCarts"
      :onShoppingCartDelete="onDeleteCruiseShoppingCart"
      :showConnectRoomPopup="showConnectRoomPopup"
    />

    <QiaohuPopup
      :shipCode="selectedCruise.shipCode"
      :sailDate="selectedCruise.sailDate"
      :onGoBack="closeQiaohuPopup"
      :isShow="isShowQiaohuPopup"
    />

    <StarrySkyPopup
        :shipCode="selectedCruise.shipCode"
        :sailDate="selectedCruise.sailDate"
        :onGoBack="closeStarrySkyPopup"
        :isShow="isShowStarrySkyPopup"
    />

    <CustomThemePopup
        :onGoBack="closeCustomThemePopup"
        :isShow="isShowCustomThemePopup"
        :themeInfo="personalizedStateroomInfo"
    />

    <ConnectRoomPopup
      :onGoBack="closeConnectRoomPopup"
      :isShow="isShowConnectRoomPopup"
    />
  </div>
</template>

<script>
import api from "@/api";
import _ from "lodash";
const ShoppingCartCruise = () => import("@/components/Booking/ShoppingCartCruise");
const CruiseShoppingCart = () => import("@/components/Cruise/CruiseShoppingCart");
const QiaohuPopup = () => import("@/components/Cruise/QiaohuPopup");
const ConnectRoomPopup = () => import("@/components/Cruise/ConnectRoomPopup");
const CustomThemePopup =()=> import("@/components/Cruise/CustomThemePopup.vue")
import { gioTracking } from "@/utilities/tools";
import StarrySkyPopup from "@/components/Cruise/StarrySkyPopup.vue";

export default {
  name: "ShoppingCart",
  components: {
    StarrySkyPopup,
    ShoppingCartCruise,
    CruiseShoppingCart,
    QiaohuPopup,
    ConnectRoomPopup,
    CustomThemePopup
  },
  data() {
    return {
      shoppingCarts: [],
      selectShoppingCarts: [],
      sailDate: "",
      shipCode: "",
      isNavFixed: false,
      isShowQiaohuPopup: false,
      isShowConnectRoomPopup: false,
      isShowStarrySkyPopup: false,
      isShowCustomThemePopup: false,
      personalizedStateroomInfo: null
    };
  },
  beforeMount() {
    const userToken = this.$store.state.user.userToken;
    if (!userToken || userToken.length == 0) {
      return this.$router.push({
        name: "Login",
        query: {
          returnUrl: location.href,
        },
      });
    } else {
      this.initPage();
    }
    this.$store.commit("SET_PAGE_TITLE", "购物车");
    const self = this;
    window.addEventListener("scroll", function () {
      self.pageScrollHandler(window.scrollY);
    });
    window.onpopstate = () => {
      if (self.isShowQiaohuPopup) {
        self.closeQiaohuPopup();
      }
      if (self.isShowConnectRoomPopup) {
        self.closeConnectRoomPopup();
      }
    };
  },
  beforeDestroy() {
    window.onpopstate = () => {};
  },
  methods: {
    initPage() {
      const query = this.$router.currentRoute.query;
      if (query.shipCode && query.shipCode.length > 0) {
        this.shipCode = query.shipCode;
      }
      if (query.sailDate && query.sailDate.length > 0) {
        this.sailDate = query.sailDate;
      }
      this.getShoppingCart(true);
    },
    async getShoppingCart(isFirstLoad) {
      this.$loading.show();
      const userToken = this.$store.state.user.userToken;
      if (userToken && userToken.length > 0) {
        const { data } = await api.booking.getShoppingCart({
          type: 0,
          userName: userToken,
        });
        if (data) {
          this.getShoppingCartSuccessHandler(data, isFirstLoad);
          this.$store.dispatch("GET_SHOPPING_CART_COUNT");
        }
      }
      this.$loading.hide();
    },
    getShoppingCartSuccessHandler(data, isFirstLoad) {
      if (!data.bookings) {
        data.bookings = [];
      }
      // 过滤row航线
      let shoppingCarts = data.bookings.filter(
        (r) => r.cruisePartRecord && !r.cruisePartRecord.isRow
      );
      // 默认第一条航线自动选中，如果url上带有shipCode,saildate，那先把这条航线购物车放到最顶端，再默认选中
      if (
        this.shipCode &&
        this.shipCode.length > 0 &&
        this.sailDate &&
        this.sailDate.length > 0
      ) {
        let lists = shoppingCarts.filter(
          (r) => r.shipCode == this.shipCode && r.sailDate == this.sailDate
        );
        if (lists && lists.length > 0) {
          shoppingCarts = shoppingCarts.filter(
            (r) => !(r.shipCode == this.shipCode && r.sailDate == this.sailDate)
          );
          shoppingCarts = lists.concat(shoppingCarts);
        }
      }
      this.shoppingCarts = shoppingCarts;
      if (
        shoppingCarts.length > 0 &&
        this.selectShoppingCarts.length == 0 &&
        isFirstLoad
      ) {
        const firstCruiseId = shoppingCarts[0].cruiseId;
        const firstCruiseShoppingCarts = shoppingCarts.filter(
          (r) => r.cruiseId == firstCruiseId
        );
        this.selectShoppingCarts = firstCruiseShoppingCarts;
      }
    },
    getSelectShoppingCartsByCruise(shipCode, sailDate) {
      return this.selectShoppingCarts.filter(
        (r) => r.shipCode == shipCode && r.sailDate == sailDate
      );
    },
    // 选择航线，如果之前都选中了，就反选，其他情况都选中
    onCruiseSelected(shoppingCarts) {
      if (!shoppingCarts || shoppingCarts.length == 0) return;
      const cruiseId = shoppingCarts[0].cruiseId;
      const selected = this.selectShoppingCarts.filter(
        (r) => r.cruiseId == cruiseId
      );
      if (shoppingCarts.length == selected.length) {
        // 反选
        this.selectShoppingCarts = [];
      } else {
				// 添加
        this.selectShoppingCarts = [];
        shoppingCarts.forEach((shoppingCart) => {
          this.selectShoppingCarts.push(shoppingCart);
        });
				gioTracking('track','evt_CartBoxChecked')
      }
    },
    // 选择舱房，如果有选中就删除，没有就选中，并反选其他航线的
    onStateroomSelected(shoppingCarts) {
      if (shoppingCarts.length == 0) return;
      const shoppingCart = shoppingCarts[0];
			let alreadyIn = this.selectShoppingCarts.some(
				(r) =>
					r.cruiseId == shoppingCart.cruiseId &&
					r.berthedCategoryCode == shoppingCart.berthedCategoryCode &&
					r.isnrp == shoppingCart.isnrp
			);
      if (alreadyIn) {
				// 删除
        this.selectShoppingCarts = this.selectShoppingCarts.filter(
          (r) =>
            !(
              r.cruiseId == shoppingCart.cruiseId &&
              r.berthedCategoryCode == shoppingCart.berthedCategoryCode &&
              r.isnrp == shoppingCart.isnrp
            )
        );
      } else {
				// 添加
        this.selectShoppingCarts = this.selectShoppingCarts.filter(
          (r) => r.cruiseId == shoppingCart.cruiseId
        );
        this.selectShoppingCarts = this.selectShoppingCarts.concat(
          shoppingCarts
        );
				gioTracking('track','evt_CartBoxChecked')
      }
    },
    // 选择连通房
    onConnectRoomSelected(connectId, cruiseId) {
			let alreadyIn = this.selectShoppingCarts.some((r) => r.connectId == connectId);
      if (alreadyIn) {
				// 删除
        this.selectShoppingCarts = this.selectShoppingCarts.filter(
          (r) => r.connectId != connectId
        );
      } else {
				// 添加
        this.selectShoppingCarts = this.selectShoppingCarts.filter(
          (r) => r.cruiseId == cruiseId
        );
        const shoppingCarts = this.shoppingCarts.filter(
          (r) => r.connectId == connectId
        );
        this.selectShoppingCarts = this.selectShoppingCarts.concat(
          shoppingCarts
        );
				gioTracking('track','evt_CartBoxChecked')
      }
    },
    // 点击加号添加购物车
    async onAddShoppingCart(shoppingCart) {
      let requestData = {
        viewModel: {
          shipCode: shoppingCart.shipCode,
          sailDate: shoppingCart.sailDate,
          productPackageId: -1,
          packageId: shoppingCart.packageId,
          stateroomCategoryCode: shoppingCart.berthedCategoryCode,
          stateroomClass: shoppingCart.stateroomType,
          fareCode: shoppingCart.fareCode,
          guestNumber: shoppingCart.guestNumber,
          originAmount: shoppingCart.originAmount,
          netAmount: shoppingCart.netAmount,
          isNrp: shoppingCart.isnrp,
          groupAgencyId: shoppingCart.groupAgencyId || "",
          groupAgencyName: shoppingCart.agencyName || "",
          requestsequence: shoppingCart.requestSequence || "",
          groupType: shoppingCart.groupType || "",
          groupId: shoppingCart.groupId || "",
          connectId: "",
        },
      };
      try {

        if (window.gio && requestData.viewModel.isNrp) {
          gioTracking("track", "NRP_ShoppingcarBF01");
        }
				gioTracking("track", "BF_EventTracking");

        gioTracking("track", "evt_CartAddRoom", {
          GuestNumber: requestData.viewModel.guestNumber,
          RoomClass: requestData.viewModel.stateroomClass,
          RoomCategory: requestData.viewModel.stateroomCategoryCode,
					RoomType: requestData.viewModel.groupType == 'QIAOHU' ? 'Qiaohu': 'nil'
        });

      } catch (e) {
        console.error(e);
      }

      this.$loading.show();
      const { success, data, errMsg } = await api.booking.addShoppingCart(
        requestData
      );
      this.$loading.hide();
      if (!success) {
        this.$alert.show(errMsg);
        return;
      }
      let newShoppingCart = _.cloneDeep(shoppingCart);
      newShoppingCart.shoppingCartId = data.shoppingCartId;
      this.shoppingCarts.push(newShoppingCart);
      this.$store.dispatch("GET_SHOPPING_CART_COUNT");

      // 检查舱房是否已经被选中，选中的话还需要push到selectShoppingCart里面
      if (
        this.selectShoppingCarts.some(
          (r) =>
            r.cruiseId == newShoppingCart.cruiseId &&
            r.berthedCategoryCode == newShoppingCart.berthedCategoryCode &&
            r.isnrp == newShoppingCart.isnrp
        )
      ) {
        this.selectShoppingCarts.push(newShoppingCart);
      }
    },
    // 减号删除舱房
    async onDeleteShoppingCart(shoppingCart) {
      const requestData = this.getShoppingCartRequest(shoppingCart);
      await this.callDeleteShoppingCartApi(
        requestData,
        shoppingCart.shoppingCartId
      );
    },
    async onDeleteCruiseShoppingCart(shoppingCart) {
      const requestData = this.getShoppingCartRequest(shoppingCart);
      await this.callDeleteShoppingCartApi(
        requestData,
        shoppingCart.shoppingCartId
      );
    },
    async callDeleteShoppingCartApi(requestData, shoppingCartId) {
      try {
        if (window.gio && requestData.viewModel.isNrp) {
          gioTracking("track", "NRP_ShoppingcarBF01");
        }
      } catch (e) {
        console.error(e);
      }

      this.$loading.show();
      const { success, errMsg } = await api.booking.deleteShoppingCart(
        requestData
      );
      this.$loading.hide();
      if (!success) {
        this.$alert.show(errMsg);
        return;
      }
      this.$store.dispatch("GET_SHOPPING_CART_COUNT");
      if (
        requestData.viewModel.connectId &&
        requestData.viewModel.connectId.length > 0
      ) {
        this.shoppingCarts = this.shoppingCarts.filter(
          (r) => r.connectId != requestData.viewModel.connectId
        );
      } else {
        this.shoppingCarts = this.shoppingCarts.filter(
          (r) => r.shoppingCartId != shoppingCartId
        );
      }
    },
    getShoppingCartRequest(shoppingCart) {
      const requestData = {
        viewModel: {
          shipCode: shoppingCart.shipCode,
          sailDate: shoppingCart.sailDate,
          productPackageId: -1,
          packageId: shoppingCart.packageId,
          stateroomCategoryCode: shoppingCart.stateroomCategoryCode ? shoppingCart.stateroomCategoryCode : shoppingCart.berthedCategoryCode,
          stateroomClass: shoppingCart.stateroomType,
          fareCode: shoppingCart.fareCode,
          guestNumber: shoppingCart.guestNumber,
          originAmount: shoppingCart.originAmount,
          netAmount: shoppingCart.netAmount,
          isNrp: shoppingCart.isnrp,
          groupAgencyId: shoppingCart.groupAgencyId || "",
          groupAgencyName: shoppingCart.agencyName || "",
          requestsequence: shoppingCart.requestSequence || "",
          groupType: shoppingCart.groupType || "",
          groupId: shoppingCart.groupId || "",
          connectId: shoppingCart.connectId || "",
        },
      };
      return requestData;
    },
    // 删除连通房
    async onDeleteConnectRoom(connectId) {
      const connectRooms = this.shoppingCarts.filter(
        (r) => r.connectId == connectId
      );
      if (!connectRooms || connectRooms.length == 0) return;
      await this.onDeleteCruiseShoppingCart({
        connectId,
        guestNumber: connectRooms[0].guestNumber,
        shipCode: connectRooms[0].shipCode,
        sailDate: connectRooms[0].sailDate,
        stateroomCategoryCode: connectRooms[0].berthedCategoryCode,
      });
    },
    // 删除多间舱房
    async onDeleteByStateroom(shoppingCarts) {
      this.$loading.show();
      for (let i = 0; i < shoppingCarts.length; i++) {
        const requestData = this.getShoppingCartRequest(shoppingCarts[i]);
        try {
          if (window.gio && requestData.viewModel.isNrp) {
            gioTracking("track", "NRP_ShoppingcarBF01");
          }
        } catch (e) {
          console.error(e);
        }

        const { success, errMsg } = await api.booking.deleteShoppingCart(
          requestData
        );
        if (!success) {
          this.$alert.show(errMsg);
          this.$loading.hide();
          return;
        }
      }
      this.$loading.hide();
      this.getShoppingCart(false);
    },
    // 删除购物车，并添加心愿单
    async onDeleteCruiseClicked(shipCode, sailDate, packageId, cruiseId) {
      this.$loading.show();
      const deleteCruise = {
        viewModel: {
          shipCode: shipCode,
          sailDate: sailDate,
          packageId: packageId,
          productPackageId: -1,
        },
      };
      const { success, errMsg } = await api.booking.deleteShoppingCartCruise(
        deleteCruise
      );
      if (!success) {
        this.$loading.hide();
        this.$alert.show(errMsg);
        return;
      }
      this.$loading.hide();
      this.addWishList(cruiseId);
      this.getShoppingCart(false);
    },
    // 添加心愿单
    async addWishList(cruiseId) {
      this.$loading.show();
      const requestData = {
        cruiseId: cruiseId,
        source: "mobile",
      };
      await api.cruise.addWishList(requestData);
      this.$loading.hide();
    },
    showQiaohuPopup() {
      this.isShowQiaohuPopup = true;
      this.showPopup();
    },
    closeQiaohuPopup() {
      this.isShowQiaohuPopup = false;
    },
    showStarrySkyPopup() {
      this.isShowStarrySkyPopup = true;
      this.showPopup();
    },
    closeStarrySkyPopup() {
      this.isShowStarrySkyPopup = false;
    },
    showCustomThemePopup(val) {
      this.personalizedStateroomInfo = val;
      this.isShowCustomThemePopup = true;
    },
    closeCustomThemePopup() {
      this.isShowCustomThemePopup = false;
    },
    showConnectRoomPopup() {
      this.isShowConnectRoomPopup = true;
      this.showPopup();
    },
    closeConnectRoomPopup() {
      this.isShowConnectRoomPopup = false;
    },
    showPopup() {
      history.pushState({ page: "shoppingCart" }, null);
    },
    pageScrollHandler(scrollTop) {
      if (scrollTop > 110) {
        this.isNavFixed = true;
      } else {
        this.isNavFixed = false;
      }
    },
  },
  computed: {
    hpShoppingCartCount() {
      return this.$store.state.booking.hpShoppingCartCount;
    },
    rowShoppingCartCount() {
      return this.$store.state.booking.rowShoppingCartCount;
    },
    // 将购物车按照航线切分
    cruiseShoppingCarts() {
      let cruises = [];
      this.shoppingCarts.forEach((shoppingCart) => {
        let cruise = cruises.filter(
          (r) =>
            r.cruise.shipCode == shoppingCart.shipCode &&
            r.cruise.sailDate == shoppingCart.sailDate
        );
        if (cruise.length > 0) {
          cruise[0].shoppingCarts.push(shoppingCart);
        } else {
          cruises.push({
            cruise: {
              shipCode: shoppingCart.shipCode,
              sailDate: shoppingCart.sailDate,
            },
            shoppingCarts: [shoppingCart],
          });
        }
      });
      return cruises;
    },
    selectedCruise() {
      if (this.selectShoppingCarts.length == 0) {
        return {};
      }
      console.log(this.selectShoppingCarts[0])
      return this.selectShoppingCarts[0];
    },
    rowShoppingCartLink() {
      const rowLink = `${process.env.VUE_APP_TUI_URL}/Booking/MobileShoppingCart`;
      return `${
        process.env.VUE_APP_BASE_URL
      }/Rccl.Campaign/RedirectToTui?redirectUrl=${encodeURIComponent(rowLink)}`;
    },
  },
  watch: {
    // 当购物车发生变动时，需要检查已选中的舱房是否已经删除
    shoppingCarts(newOne) {
      const shoppingCartIds = newOne.map((r) => r.shoppingCartId);
      this.selectShoppingCarts = this.selectShoppingCarts.filter((r) =>
        shoppingCartIds.some((sc) => sc == r.shoppingCartId)
      );
    },
  },
};
</script>

<style lang="less" scoped>
.shoppingCart {
  background-color: #f6f7f8;
  margin-top: 50px;
  .shoppingCartContent {
    // margin-top: -40px;
    // height: calc(100% + 50px);
    .normalCar {
      padding-bottom: 120px;
      .pullDownRefresh {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -moz-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 14px 0 12px;
        font-size: 11px;
        line-height: 14px;
        color: #666;
        img {
          display: block;
          width: 12px;
          margin-right: 5px;
        }
      }
    }
  }
  .carCategory {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    .carCategory-tab {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -moz-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      position: relative;
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -moz-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      height: 46px;
      font-size: 14px;
      line-height: 46px;
      .carCategory-tab-bg {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
        width: 204px;
        max-width: unset;
      }
      .carCategory-tab-txt {
        position: relative;
        z-index: 5;
        height: 100%;
        padding: 0 5px;
      }
      .carCategory-tab-num {
        position: absolute;
        left: 100%;
        top: 50%;
        -webkit-transform: translate3d(0, -50%, 0);
        -moz-transform: translate3d(0, -50%, 0);
        transform: translate3d(0, -50%, 0);
        width: 16px;
        height: 16px;
        font-size: 12px;
        line-height: 16px;
        color: #fff;
        text-align: center;
        font-weight: bold;
        background-color: #ff5055;
        border-radius: 100%;
      }
    }

    .carCategory-tab-l {
      .carCategory-tab-bg {
        left: 0;
        z-index: 1;
      }
      .carCategory-tab-txt {
        color: #fff;
        font-weight: bold;
      }
    }
    .carCategory-tab-r {
      .carCategory-tab-bg {
        right: 0;
      }
      .carCategory-tab-txt {
        color: #666;
      }
    }
  }

  .carCategory2 {
    position: fixed;
    left: 0;
    top: 50px;
    z-index: 100;
    width: 100%;
    background: #ffffff;
    -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
    .carCategory-tab-l::before {
      content: "";
      position: absolute;
      right: 0;
      top: 50%;
      -webkit-transform: translateY(-50%);
      -moz-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      -o-transform: translateY(-50%);
      transform: translateY(-50%);
      width: 1px;
      height: 26px;
      background-color: #ccc;
    }
    .carCategory-tab-l .carCategory-tab-txt {
      color: #4a90e2;
    }
    .carCategory-tab-l .carCategory-tab-txt::before {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #4a90e2;
      border-radius: 2px;
    }
  }

  #carCategory-normal1.hide {
    opacity: 0;
  }

  .emptyCar {
    .emptyCar-m {
      padding: 86px 0 20px;
      .emptyCar-m-icon {
        display: block;
        width: 45px;
        margin: 0 auto 15px;
      }
      .emptyCar-m-txt {
        padding-bottom: 10px;
        font-size: 14px;
        line-height: 21px;
        color: #aaa;
        text-align: center;
      }
      .emptyCar-m-link {
        text-align: center;
        a {
          display: inline-block;
          padding: 0 20px;
          font-size: 14px;
          line-height: 21px;
          color: #4a90e2;
          border: 1px solid #4a90e2;
          border-radius: 14px;
        }
      }
    }
  }
}
</style>
